import React, { useContext } from "react";
import TX from "./TX";
import SG from "./SG";
import SL from "./SL";
import SLExpand from "./SLExpand";
import CB from "./CB";
import CBScroll from "./CBScroll";
import DCL from "./DCL";
import TL from "./TL";
import ProductCard from "./ProductCard";
import BC from "./BC";
import CL from "./CL";
import LO from "./LO";
import RESERVE from "./RESERVE";
import HELPCARD from "./HELPCARD";
import EventCard from "./EventCard";
import CareCard from "./CareCard";
import TICard from "./TICard";
import Debug from "./Debug";
import DeviceGrid from "./DeviceGrid";
import PC from "./PC";
import DataContext from "../../data/DataContext";
import SCL from "./SCL";
import StoryCard from "./StoryCard";
import AccessoryCard from "./AccessoryCard";
import IB from "./IB";
import WELCOME from "./WELCOME"
import STARTMENU from "./STARTMENU";
import DateMsg from "./DateMsg";
import PRDC from "./PRDC";
import LB from "./LB";
import SGICGrid from "./SGICGrid";
import SGICLO from "./SGICLO";
import SGICHorizontal from "./SGICHorizontal";
import SGVertical from "./SGVertical";
import SGGrid from "./SGGrid";
import SubscriptionCard from "./SubscriptionCard";
import SubspackageCard from "./SubspackageCard";
import ModalTest from "../../modal/ModalTest"

function Message(props) {
  const { data } = props;
  const context = useContext(DataContext);

  const getMessage = () => {
    if (data && (data.isOld === true ? context.isShowOldConversations : true)) {
      switch (data.type.toUpperCase()) {
        case "DATE":
          return <DateMsg data={data} />
        case "TX":
          return <TX data={data} />;
        case "CB":
          return <CB data={data} />;
        case "CBSCROLL":
          return <CBScroll data={data} />;
        case "DCL":
          return <DCL data={data} />;
        case "TL":
          return <TL data={data} />;
        case "SL":
          return <SL data={data} />;
        case "SLEXPAND":
          return <SLExpand data={data} />;
        case "SG":
          return <SG data={data} />;
        case "BC":
          return <BC data={data} />;
        case "CL":
          return <CL data={data} />;
        case "LO":
          return <LO data={data} />;
        case "RESERVE":
          return <RESERVE data={data} />;
        case "HELPCARD":
          return <HELPCARD data={data} />;
        case "PRODUCTCARD":
          return <ProductCard data={data} />;
        case "EVENTCARD":
          return <EventCard data={data} />;
        case "CARECARD":
          return <CareCard data={data} />;
        case "TICARD":
          return <TICard data={data} />;
        case "SELECTCARDLIST":
          return <SCL data={data} />;
        case "DEBUG":
          return <Debug data={data} />;
        case "GRID":
          return <DeviceGrid data={data} />;
        case "PC":
          return <PC data={data} />;
        case "STORYCARD":
          return <StoryCard data={data} />;
        case "ACCESSORYCARD":
          return <AccessoryCard data={data} />;
        case "IB":
          return <IB data={data}/>;
        case "WELCOME":
          return <WELCOME data={data}/>;
        case "STARTMENU":
          return <STARTMENU data={data}/>;
        case "PRDC":
          return <PRDC data={data}/>;
        case "LB":
          return <LB data={data}/>;
        case "SGICGRID":
          return <SGICGrid data={data}/>;
        case "SGICLO":
          return <SGICLO data={data}/>;
        case "SGICHORIZONTAL":
          return <SGICHorizontal data={data}/>;
        case "SGVERTICAL":
          return <SGVertical data={data}/>;
        case "SGGRID":
          return <SGGrid data={data}/>;
        case "MODALTEST":
          return <ModalTest data={data}/>;
        case "SUBSCRIPTIONCARD":
          return <SubscriptionCard data={data}/>;
        case "SUBSPACKAGECARD":
          return <SubspackageCard data={data}/>;
        default:
          return null;
      }
    }
  };

  return <>{getMessage()}</>;
}
export default Message;
